<template>
    <div class="cw_query_input">
        <span class="input_title">{{label}}</span>    
        <el-input  :value="propertyData[propertyName]"  @input="onInputChange($event,propertyName)"  :placeholder="placeholder">      
            <div slot="append">
                <el-button  :icon="icon" @click="onPopDialog"></el-button>
            </div>            
       </el-input>
       <el-dialog  width="900px" customClass="dialog_detail_style" :title="windowTitle" :visible.sync="showDialog"  v-dialogDrag>
			<slot></slot>
	   </el-dialog>
    </div>
</template>

<script>
import Panel from 'components/container/Panel.vue'
export default {
    components:{
        Panel
    },
    props:{
        label:{
            type:String,
            default:()=>{
                return '输入框标题:'
            }
        },
        inputProperty:{
           type:String,
            default:()=>{
                return 'temp'
            }
        },
        propertyObject:{
            type:Object,
             default:()=>{
                return {
                    temp:'未绑定字段'
                }
            }
        },
        placeholder:{
            type:String,
            default:()=>{
                return '请输入检索信息'
            }
        },
        icon:{
            type:String,
            default:()=>{
                return 'el-icon-search'
            }
        },
        initDialogVisible:{
            type:Boolean,
            default:()=>{
                return false;
            }
        },
        windowTitle:{
            type:String,
            default:()=>{
                return '输入框窗口'
            }
        }
    },
    created(){
       //初始化输入框
       this.initInput();
    },
    data(){
       return {
           showDialog:this.initDialogVisible,
           propertyName:undefined,
           propertyData:{}
       }
    },
    methods:{

         /**
         * 初始化输入库
         */
        initInput(){ 
          if(!this.inputProperty) return;

          this.propertyName=this.inputProperty;
          if(!this.propertyObject[this.propertyName]){
              this.$set(this.propertyObject,this.propertyName,"");
          }        
          this.propertyData=this.propertyObject;
        },

        onPopDialog(){
            this.showDialog=true;
        },
        closeQueryWindow(){
            this.showDialog=false;
        },
        openQueryWindow(){
            this.onPopDialog();
        },
        /**
         * 输入值已更改事件
         */
        onInputChange(event,field){
             this.$set(this.propertyData,field,event);
             this.propertyData= Object.assign({},this.propertyData);
        },
    }
}
</script>

<style scoped>
  .cw_query_input {
      line-height: normal;
      display: inline-table;
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
  }

  .input_title{
     /* width:20%; */
     font-size: 1px
  }

  .cw_query_input div{
     width: 100%;   
  }

  .cw_query_input .el-input-group--append{
  }

   .cw_query_input .el-input-group{
  }
  
</style>